<chart class="chart-container" [options]="options" *ngIf="chartData && chartData.length > 0">
</chart>
<div *ngIf="titleTooltip" class="tooltip-title-wrapper">
  <achoo-icon-tooltip [tooltipMsg]="titleTooltip"></achoo-icon-tooltip>
</div>
<div class="message-container"
  *ngIf="!chartData || chartData.length === 0">
  <achoo-column-chart-placeholder [chartTitle]="chartTitle" [height]="height"></achoo-column-chart-placeholder>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-column-chart/achoo-column-chart.component.html